<template>
  <div>
    <c-row>
      <c-col col="2"><label class="font-weight-bold pt-2">{{label}}</label></c-col>
      <c-col col="10"><slot name="field"></slot></c-col>
    </c-row>
  </div>
</template>

<script>
export default {
  name: 'FormRow',
  props: ['label']
}
</script>
